import PlaceholderPage from "../../modules/shared/component/PlaceholderPage";

import React from "react";

const JobVacancy: React.FC = () => {
  return <PlaceholderPage title="Job Vacancy" />;
};

export default JobVacancy;
